import React, { useState, createContext, useContext, useMemo } from 'react'
import { useCauses } from '@context/CausesContext/CausesContext'
import { useOrganization } from '@context/OrganizationContext/OrganizationContext'
import { useEventData } from '@hooks/useEventData'
import { EventContextProps, EventContextDefaultValues } from '@Interfaces/Data/EventInterface'
import { Event } from '@Interfaces/Data/EventInterface'
import { ContextComponentProps } from '@Interfaces/Util/CommonInterface'

export const EventsContext = createContext<EventContextProps>(EventContextDefaultValues)

export const EventsProvider = ({ children }: ContextComponentProps) => {
  const { selectedOrg } = useOrganization()
  const { allCauses } = useCauses()
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null)

  const {
    upcomingEvents,
    setUpcomingEvents,
    pastEvents,
    setPastEvents,
    eventDonations,
    setEventDonations,
    causes,
  } = useEventData(selectedOrg, allCauses, selectedEvent)

  const contextValue = useMemo(
    () => ({
      upcomingEvents,
      setUpcomingEvents,
      pastEvents,
      setPastEvents,
      selectedEvent,
      setSelectedEvent,
      causes,
      eventDonations,
      setEventDonations,
    }),
    [upcomingEvents, pastEvents, selectedEvent, causes, eventDonations]
  )

  return <EventsContext.Provider value={contextValue}>{children}</EventsContext.Provider>
}

export const useEvents = (): EventContextProps => useContext(EventsContext)
